import React from "react";
import { useAuth } from "../context/AuthContext";
import InternalLink from "../components/InternalLink";
import Icon from "../components/Icon";
import FavoriteButton from "../components/FavoriteButton";
import { formatDistanceToNow } from "date-fns";

function DashboardWorkflowCard({
    workflow,
    isFavorite,
    onFavoriteChange,
    to,
}) {
    const { interfaceStyle } = useAuth();

    const isExpertNonV2 =
        interfaceStyle === "expert" && workflow.workflowType !== "APP_V2";
    const linkTo =
        to ??
        (isExpertNonV2
            ? `/workflows/${workflow.id}`
            : `/chat/${workflow.id}/chat`);

    const stepCount = workflow._count?.steps ?? 0;
    const timeAgo = workflow.updatedAt
        ? formatDistanceToNow(new Date(workflow.updatedAt), { addSuffix: true })
        : "";
    const showFavorite = isFavorite !== undefined;

    return (
        <InternalLink
            to={linkTo}
            className="relative border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col group"
        >
            {workflow.screenshotUrl ? (
                <img
                    src={workflow.screenshotUrl}
                    alt={workflow.name}
                    className="w-full aspect-video object-cover bg-gray-50"
                />
            ) : (
                <div className="w-full aspect-video bg-gray-50 flex items-center justify-center">
                    <Icon
                        name={
                            workflow.workflowType === "APP_V2"
                                ? "AppWindow"
                                : "Workflow"
                        }
                        className="w-10 h-10 text-gray-300"
                    />
                </div>
            )}
            {showFavorite && (
                <div className="absolute top-2 right-2 bg-white/85 backdrop-blur-sm rounded-full shadow-sm">
                    <FavoriteButton
                        workflowId={workflow.id}
                        isFavorite={isFavorite}
                        onFavoriteChange={onFavoriteChange}
                        size={16}
                    />
                </div>
            )}
            <div className="p-3 space-y-1">
                <p className="font-medium text-sm truncate">{workflow.name}</p>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                    {workflow.workflowType !== "APP_V2" && stepCount > 0 && (
                        <span>{stepCount} steps</span>
                    )}
                    {timeAgo && <span>{timeAgo}</span>}
                </div>
            </div>
        </InternalLink>
    );
}

export default DashboardWorkflowCard;
